import { Trans } from '@lingui/react/macro';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import ChatComposer from 'modules/chat/ui/components/chat-composer';
import ChatQuotaBar from 'modules/chat/ui/components/chat-quota-bar';
import ChatTranscript from 'modules/chat/ui/components/chat-transcript';
import { useChat } from 'modules/chat/ui/hooks/use-chat';
import { getChatErrorText } from 'modules/chat/ui/utils';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { i18n } from 'shared/i18n';
import { UDButton } from 'ud-ui/components';
import UDHeaderTitle from 'ud-ui/components/header-title';

const ChatPage: React.FC = () => {
  const { setHeaderContent } = useMainLayout();
  // Без фичи `AI_CHAT_ASSISTANT` сюда не попасть: роут уводит на тариф (`FeatureRoute`).
  const { messages, isSending, isClearing, error, quota, sendMessage, clearHistory, confirmWrite, cancelWrite } = useChat();

  useEffect(() => {
    setHeaderContent(
      <UDHeaderTitle>
        <Trans>ИИ-ассистент</Trans>
      </UDHeaderTitle>,
    );
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  // Тост показывается один раз на ошибку: `i18n` — глобальный, чтобы смена языка не повторяла тост.
  useEffect(() => {
    if (error) {
      toast.error(getChatErrorText(error, (descriptor) => i18n._(descriptor)));
    }
  }, [error]);

  return (
    <div className="flex h-full w-full flex-col gap-3 px-6 py-6">
      <div className="flex items-center justify-between gap-3">
        <div>
          <ChatQuotaBar quota={quota} />
        </div>
        <UDButton variant="secondary" slim onClick={clearHistory} loading={isClearing} disabled={messages.length === 0}>
          <Trans>Очистить историю</Trans>
        </UDButton>
      </div>

      <div className="flex flex-1 flex-col overflow-hidden rounded-lg bg-white">
        <ChatTranscript messages={messages} isSending={isSending} onConfirmWrite={confirmWrite} onCancelWrite={cancelWrite} />
      </div>

      <ChatComposer disabled={isSending} onSubmit={sendMessage} />
    </div>
  );
};

export default ChatPage;
